import baseRoute from '../baseRoute';

export type * from './viewModel';

type RouteDefinition = `${typeof baseRoute}/${number | ':jobId'}/invoiceCodes`;

export const ROUTE: RouteDefinition = `${baseRoute}/:jobId/invoiceCodes`;

export const URL = (jobId: number): RouteDefinition => `${baseRoute}/${jobId}/invoiceCodes`;
